<template>
  <div>
    <router-view></router-view> 
  </div>
</template>
<script> 

export default {
  data() {
    return {
      showChat: false
    }
  },
  components: { 
  }
}
</script>

<style lang="less">
#app {
  width: 100vw;
  height: 100vh;
}

* {
  user-select: none;
  margin: 0;
  padding: 0;
}

.cup {
  cursor: pointer;
}

.u-line-1 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.u-line-2 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.u-line-3 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
</style>
<style>
.animate-fade-out {
  animation: fadeOut .5s ease-in-out;
}

@keyframes fadeOut {
  from {
    opacity: 0;
    transform: translateY(100px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-out-2 {
  animation: fadeOut .5s 0.2s ease-in-out;
}

.animate-fade-out-4 {
  animation: fadeOut .5s 0.4s ease-in-out;
}

.animate-fade-out-6 {
  animation: fadeOut .5s 0.6s ease-in-out;
}


.animate-fade-in {
  animation: fadeIn 1s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}


.animate-slide-in-left {
  animation: slideInLeft 0.8s 1s ease-out;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-slide-in-right {
  animation: slideInRight 0.8s ease-out;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(60px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-scale {
  animation: slideScale 0.8s ease-out;
}

@keyframes slideScale {
  from {
    transform: scale(1.2);
  }

  50% {
    transform: scale(1.4);
  }

  to {
    transform: scale(1);
  }
}

.animate-scale-small-big {
  animation: slideScale 0.8s ease-out;
}

@keyframes slideScale {
  from {
    transform: scale(0.8);
  }

  to {
    transform: scale(1);
  }
}

.rotate {
  animation: rotateAnimation 1s linear;
}

@keyframes rotateAnimation {
  from {
    transform: scale(.6) rotate(240deg);
  }

  to {
    transform: scale(1) rotate(360deg);
  }
}



</style>


// WEBPACK FOOTER //
// src/App.vue